import {useCallback} from 'react';

import {DataFrame} from 'data-frames/DataFrameTypes';
import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';
import useOnChangeOnly from 'ui-library/hooks/useOnChangeOnly';

interface UseDataFrameTablePaginationOutput {
  rowsOffset: number;
  onChangeRowsOffset: (rowsOffset: number) => void;
}

const DEFAULT_PAGINATION_OFFSET = 0;

const dataFrameTablePaginationState = makeUseGlobalClientState(DEFAULT_PAGINATION_OFFSET);

// This hook is very simple at the moment, but we anticipate adding more logic once we
// implement server-side pagination.
export default function useDataFrameTablePaginationState(
  clientStateId: string,
  dataFrame: DataFrame
): UseDataFrameTablePaginationOutput {
  const [rowsOffset, setRowsOffset] = dataFrameTablePaginationState.useGlobalClientState(clientStateId);

  const onChangeRowsOffset = useCallback(
    (rowsOffset: number) => {
      setRowsOffset(rowsOffset);
    },
    [setRowsOffset]
  );

  useOnChangeOnly(() => {
    onChangeRowsOffset(DEFAULT_PAGINATION_OFFSET);
  }, [dataFrame.rows, onChangeRowsOffset]);

  return {
    // The `useOnChangeOnly` call will reset `rowsOffset` when `rows` changes, but that will not take effect
    // in this render. For safety, ensure the `rowsOffset` is not invalid for `rows`.
    rowsOffset: rowsOffset > dataFrame.rows.length ? DEFAULT_PAGINATION_OFFSET : rowsOffset,
    onChangeRowsOffset,
  };
}
